window.TemplateRegistry = (function() {
    const templates = {
        'dog-dad-v1': {
            id: 'dog-dad-v1',
            name: 'Dog Dad Template',
            layers: [
                {
                    id: 'background',
                    type: 'static_image',
                    content: 'https://cdn.shopify.com/s/files/1/0915/5788/8367/files/paw-squad-preview-navy.png',
                    visible: false,
                    zIndex: 1,
                    x: '0%',
                    y: '0%',
                    width: '100%',
                    height: '100%',
                    rotation: 0,
                    opacity: 1.0
                },
                {
                    id: 'customer-artwork',
                    type: 'dynamic_artwork',
                    visible: true,
                    zIndex: 2,
                    x: '50%',
                    y: '38%',
                    width: '24%',
                    height: '32%',
                    objectFit: 'contain',
                    objectPosition: 'bottom center',
                    rotation: 0,
                    opacity: 1.0
                },
                {
                    id: 'pet-name-text',
                    type: 'dynamic_text',
                    visible: true,
                    zIndex: 3,
                    x: '50%',
                    y: '72%',
                    width: '80%',
                    maxWidth: '80%',
                    maxHeight: '15%',
                    lineClamp: 1,
                    textOverflowStrategy: 'scale-down-or-ellipsis',
                    rotation: 0,
                    opacity: 1.0,
                    fontFamily: 'var(--font-heading-family, sans-serif)',
                    fontSize: '8cqi',
                    color: '#ffffff',
                    textAlign: 'center'
                },
                {
                    id: 'grunge-overlay',
                    type: 'static_image',
                    content: 'https://cdn.shopify.com/s/files/1/0915/5788/8367/files/vintage-grunge.png',
                    visible: true,
                    zIndex: 4,
                    x: '0%',
                    y: '0%',
                    width: '100%',
                    height: '100%',
                    rotation: 0,
                    opacity: 0.4,
                    blendMode: 'multiply'
                }
            ]
        }
    };

    return {
        get: function(templateId) {
            return templates[templateId] || templates['dog-dad-v1'];
        }
    };
})();
